import axios, { AxiosResponse } from "axios";
import { UserType } from "../types/user.type";
import { environment } from "../environment";

export class UserHelper {

  /**
   * Update the last login of the user
   *
   * @param user User object to update the last login
   * @returns {Promise<boolean>} True if the last login was updated successfully
   */
  static async updateUserLastLogin(
    user: UserType | undefined
  ): Promise<boolean> {
    if (!user) return false;

    const response: AxiosResponse = await axios.patch(
      `${environment.api.host}/api/user/${user.id}/last-login`,
      {},
      {
        headers: {
          Authorization: `Bearer ${user.access_token}`,
        },
      }
    );

    return response.status === 200 || response.status === 201;
  }

  /**
   * Update the user groups from the local storage
   */
  static async updateUserGroups(): Promise<UserType | undefined> {
    const userFromLocalStorage = localStorage.getItem("user");

    if (!userFromLocalStorage) return undefined;

    const userFromLocalStorageParsed = JSON.parse(userFromLocalStorage);

    try {
      const response: AxiosResponse = await axios.get(
        `${environment.api.host}/api/profile`,
        {
          headers: {
            Authorization: `Bearer ${userFromLocalStorageParsed.access_token}`,
          },
        }
      );

      const usersGroups = response.data.items[0].users_groups || [];

      userFromLocalStorageParsed.users_groups = usersGroups;
      return userFromLocalStorageParsed;
    } catch (error) {
      console.error("Error fetching user profile:", error);
      return undefined;
    }
  }
}
